module.exports = __webpack_public_path__ + "static/media/blog-2019-sommerfest-bgb.ef0de6af.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/blog-2019-sommerfest-bgb.jpeg
// module id = 77
// module chunks = 0